import Constants from '@/utils/constants';

import {
	REPORT_LIST_REQUESTING,
	REPORT_LIST_SUCCESS,
	REPORT_LIST_ERROR,
	GENERATING_REPORT_REQUESTING,
	GENERATING_REPORT_SUCCESS,
	GENERATING_REPORT_ERROR,
} from './types';

export const initialState = {
	loading: false,
	data: [],
	error: undefined,
	filters: {
		reportType: 'FORWARD_TRANSACTION',
		start: 0,
		size: Constants.PAGE_SIZE,
	},
};

function reportList(state = initialState, action) {
	switch (action.type) {
		case REPORT_LIST_REQUESTING:
			return {
				...state,
				loading: true,
				filters: action.payload,
			};
		case REPORT_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.data,
			};
		case REPORT_LIST_ERROR:
			return { ...state, loading: false, error: action.error };
		case GENERATING_REPORT_REQUESTING:
			return {
				...state,
				loading: true,
			};
		case GENERATING_REPORT_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case GENERATING_REPORT_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state;
	}
}

export default reportList;
